/** Category hub page. */
export function categoryBrowsePath(slug) {
  if (!slug) {
    return '/';
  }
  return `/shop/${encodeURIComponent(slug)}`;
}

/** Subcategory landing page (indexed). */
export function subcategoryBrowsePath(shopSlug, subSlug) {
  if (!shopSlug || !subSlug) {
    return '/';
  }
  return `/shop/${encodeURIComponent(shopSlug)}/${encodeURIComponent(subSlug)}`;
}

/** SERP scoped to a subcategory search within a shop category. */
export function subcategorySearchPath(subSearch, shopSlug) {
  const params = new URLSearchParams();
  params.set('q', subSearch);
  if (shopSlug) {
    params.set('shop', shopSlug);
  }
  return `/search?${params.toString()}`;
}

/** SERP with optional query and shop scope. */
export function categorySearchPath(query, shopSlug) {
  const trimmed = typeof query === 'string' ? query.trim() : '';
  const params = new URLSearchParams();
  if (trimmed) {
    params.set('q', trimmed);
  }
  if (shopSlug) {
    params.set('shop', shopSlug);
  }
  const qs = params.toString();
  if (!qs) {
    return '/';
  }
  return `/search?${qs}`;
}
